import { Button, Hairline, Input, Label, Radio } from "@components";
import { CurrencyInput } from "@components/CurrencyInput";
import { If } from "@components/control-statements";
import { VariableSchema } from "@containers/oraculo/VariableSchema";
import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";
import { useState } from "react";
import { TimeForm } from "./TimeForm";
import { Currency } from "shared/utils/Currency";

export default ({
  node,
  disableTimeRange = false,
  input_configs = {},
  onSave,
  onRemove,
}) => {
  const [operand, setOperand] = useState(node.operand || "gte");
  const [value, setValue] = useState(
    formatValue(node.operand, node.value || input_configs?.min || 0)
  );

  const [range, setRange] = useState(node.range || {});

  const getFreshNode = () => {
    return { ...node, operand, value, range };
  };

  const changeOperand = (_operand) => {
    if (_operand == "bt") {
      setValue([input_configs?.min || null, input_configs?.max || null]);
    }
    setOperand(_operand);
  };

  const validate = () => {
    const { min, max, type } = input_configs || {};
    if (!operand || value === null || value === undefined || value === "") {
      return false;
    }

    if (["currency", "number"].includes(type)) {
      if (min !== undefined && +value < min) {
        return false;
      }

      if (max !== undefined && +value > max) {
        return false;
      }
    }

    return true;
  };

  const is_number = ["currency", "number"].includes(input_configs?.type);
  const InputComponent = is_number ? CurrencyInput : Input;

  console.log(input_configs?.prefix);

  return (
    <>
      <div className={styles.scrollContainer}>
        <div className={styles.card}>
          <Label>Defina o uso desta variável:</Label>
          <Hairline solid className="mt-5 mb-20" />
          <Radio
            family="variableType"
            className="mb-10"
            value="eq"
            checked={operand}
            readOnly
            onChange={() => changeOperand("eq")}
          >
            Igual a
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="neq"
            readOnly
            checked={operand}
            onChange={() => changeOperand("neq")}
          >
            Diferente de
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="gte"
            readOnly
            checked={operand}
            onChange={() => changeOperand("gte")}
          >
            No mínimo
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="lte"
            readOnly
            checked={operand}
            onChange={() => changeOperand("lte")}
          >
            No máximo
          </Radio>
          <Radio
            family="variableType"
            value="bt"
            readOnly
            checked={operand}
            onChange={() => changeOperand("bt")}
          >
            Intervalo (de / até)
          </Radio>
        </div>

        <div className={styles.card}>
          <Label>Determine o valor de comparação:</Label>
          <Hairline solid className="mt-10 mb-20" />
          <If cond={operand !== "bt"}>
            <div className="d-flex align-center gap-10">
              <If cond={is_number}>
                <p className={styles.value}>
                  {input_configs?.prefix.startsWith("R$")
                    ? Currency.formatCurrency(formatValue(operand, value))
                    : formatValue(operand, value)}
                </p>
              </If>
              <If cond={!is_number}>
                <p className={styles.value}>{formatValue(operand, value)}</p>
              </If>
              <If cond={input_configs?.suffix}>
                <p className={styles.value}>{input_configs?.suffix}</p>
              </If>
            </div>
          </If>
          <If cond={operand == "bt"}>
            <div className="d-flex align-center gap-10">
              <If cond={is_number}>
                <p className={styles.value}>
                  {input_configs?.prefix.startsWith("R$")
                    ? Currency.formatCurrency(formatValue(operand, value)[0])
                    : formatValue(operand, value)[0]}
                </p>
                <p className={styles.value}>
                  {input_configs?.prefix.startsWith("R$")
                    ? Currency.formatCurrency(formatValue(operand, value)[1])
                    : formatValue(operand, value)[1]}
                </p>
              </If>
              <If cond={!is_number}>
                <p className={styles.value}>{formatValue(operand, value)[0]}</p>
                <p className={styles.value}>{formatValue(operand, value)[1]}</p>
              </If>
            </div>
          </If>
        </div>
        <If cond={!disableTimeRange}>
          <div className={styles.card}>
            <Label>Faixa de tempo:</Label>
            <Hairline solid className="mt-10 mb-20" />
            <TimeForm range={range} onChange={(r) => setRange(r)} />
          </div>
        </If>
      </div>
    </>
  );
};

const formatValue = (operand, value) => {
  if (operand == "bt") {
    return Array.isArray(value) ? value : [null, null];
  }
  return value;
};
